"use client";

import { useEffect, useState } from "react";

// Przełącznik motywu – ujednolicony przycisk (.panel-navbtn). Pozycjonowanie
// (nagłówek / pływający) zapewnia rodzic. Klasa .night na <html>, wspólny
// localStorage 'fablio_theme' z landingiem, domyślnie ciemny.
export default function ThemeToggle() {
  const [night, setNight] = useState(true);

  useEffect(() => {
    let saved: string | null = null;
    try {
      saved = localStorage.getItem("fablio_theme");
    } catch {}
    const isNight = (saved ?? "night") !== "day";
    setNight(isNight);
    document.documentElement.classList.toggle("night", isNight);
  }, []);

  function toggle() {
    const next = !night;
    setNight(next);
    document.documentElement.classList.toggle("night", next);
    try {
      localStorage.setItem("fablio_theme", next ? "night" : "day");
    } catch {}
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label="Przełącz motyw"
      title={night ? "Włącz tryb jasny" : "Włącz tryb ciemny"}
      className="panel-navbtn"
    >
      <span className="text-lg leading-none">{night ? "☀️" : "🌙"}</span>
    </button>
  );
}
